function LoggedInUserFactory(localStorageService) {
  const isWapoUser = ({ username, organization }) => {
    if (!username) {
      return false;
    }

    return organization === 'washpost' && username.indexOf('@washpost.com') !== -1;
  };

  const getCleanWapoUsername = username => username.split('@washpost.com')[0];

  const user = {
    username: localStorageService.get('username'),
    organization: localStorageService.get('organization'),
    displayName: localStorageService.get('displayName'),
    email: localStorageService.get('email'),
    groups: localStorageService.get('groups') ? localStorageService.get('groups').split(',') : null
  };

  if (isWapoUser(user)) {
    user.username = getCleanWapoUsername(user.username);
  }

  return user;
}

export default function (ngModule) {
  ngModule.factory('LoggedInUser', [
    'localStorageService',
    LoggedInUserFactory
  ]);
}
